/* eslint-disable import/extensions */
import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import GuestGuard from "utils/route-guard/GuestGuard";
import MinimalLayout from "layout/MinimalLayout";

// Department
const DoubtSection = Loadable(
  lazy(() => import("views/application/web-view/doubt-section"))
);
const AlumniPayment = Loadable(
  lazy(() => import("views/application/web-view/alumniPayment/index"))
);
const AlumniFounderPage = Loadable(
  lazy(() => import("views/application/web-view/FounderAndTrusteeMsg/FounderMsg"))
);
const AlumniTrusteePage = Loadable(
  lazy(() => import("views/application/web-view/FounderAndTrusteeMsg/TrusteeMsg"))
);
const CompleteRegistration = Loadable(
  lazy(() => import("views/application/web-view/completeProfile/CompleteRegistration"))
);


const LinkedinOauth = Loadable(
  lazy(() => import("views/application/web-view/linkedinOauth/SelectInstitute"))
);
const CreateNetwork = Loadable(
  lazy(() => import("views/application/web-view/linkedinOauth/CreateNetwork"))
);

const MenntorShip = Loadable(
  lazy(() => import("views/application/web-view/mentorship/Main"))
);




// const AlumniPayment = Loadable(
//   lazy(() => import("views/application/web-view/alumniPayment/index"))
// );




const WebViewRoutes = {
  path: "/",
  element: (
    <GuestGuard>
      <MinimalLayout />
    </GuestGuard>
  ),

  children: [
    {
      path: "/webview/doubt-section/:token",
      element: <DoubtSection />,
    },
    {
      path: "/webview/alumni-payment/:token",
      element: <AlumniPayment />,
    },
    {
      path: "/webview/complete/registration/:alumniId/:instituteId/:token",
      element: <CompleteRegistration />,
    },
    {
      path: "/webview/founderMsg/:token",
      element: <AlumniFounderPage />,
    },
    {
      path: "/webview/trusteeMsg/:token",
      element: <AlumniTrusteePage />,
    },
    {
      path: "/webview/Oauth/registration/:usertoken/:OauthToken/:type",
      element: <LinkedinOauth />,
    },
    {
      path: "/webview/create/network",
      element: <CreateNetwork />,
    },
    {
      path: "/webview/mentorship/:userId/:token",
      element: <MenntorShip />,
    },
  ],
};

export default WebViewRoutes;
